export const CommonMargin = {
  left: "30px",
  right: "30px"
};